// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"597":"56fb7c44","619":"16f0dd3c"}[chunkId] + ".chunk.js";
};